import React, { Component } from 'react';
import { Segment, Header, List } from 'semantic-ui-react';

export default class ImportantLinks extends Component {
  render() {
    return (
      <Segment vertical>
        <Header as="h1" content="Important Links" />
        <List bulleted>
          <List.Item>
            <a href="https://teams.microsoft.com/l/team/19%3aBqS3vprQgboO0n-KqCVNTTWWrQaMLpkVdX4OTxZ_Dw01%40thread.tacv2/conversations?groupId=826c1a38-dafd-474a-8f25-61a6d11224ba&tenantId=482198bb-ae7b-4b25-8b7a-6d7f32faa083" target="_blank">MS Teams workspace</a>: For
            announcements, questions, etc. Join with your @gatech.edu email address.
          </List.Item>
          <List.Item>
            Canvas <a href="https://gatech.instructure.com/courses/236378" target="_blank">CS4803 UPS</a> / <a
              href="https://gatech.instructure.com/courses/236700" target="_blank">CS8803 UPS</a>: For submitting
            reading commentaries, assignments, etc..
          </List.Item>
        </List>
      </Segment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/important-links.js